import type { Color } from 'style/types/theme';
import styled from 'styled-components';

import style from '../../../style';

interface AddColorProps {
  $disabled: boolean;
}

interface StyleProps {
  color: Color;
  $disabled: boolean;
}

const getBorderColor = ({ color, $disabled }: StyleProps) => {
  return $disabled ? color.border.primary.disabled() : color.border.primary.default();
};

const getHoverStyles = ({ color, $disabled }: StyleProps) => {
  return $disabled
    ? {
        cursor: 'not-allowed',
        border: `1px solid ${color.border.primary.disabled()}`,
      }
    : {
        cursor: 'pointer',
        border: `1px solid ${color.border.primary.hover()}`,
      };
};

const getSvgFill = ({ color, $disabled }: StyleProps) => {
  return $disabled
    ? color.content.secondary.disabled()
    : color.content.secondary.default();
};

export const Wrapper = styled.div<AddColorProps>(
  ({ theme: { size, color, transition }, $disabled }) => ({
    width: '100%',
    height: '100%',
    border: '1px solid',
    borderColor: getBorderColor({ color, $disabled }),
    borderRadius: size.units(0.5),
    transition: transition.standard('border'),

    ...style.mixins.devices.desktop({
      ':hover': getHoverStyles({ color, $disabled }),
    }),
  }),
);

export const IconWrapper = styled.div<AddColorProps>(
  ({ theme: { color, size }, $disabled }) => ({
    height: '100%',
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',

    svg: {
      width: size.units(2),
      fill: getSvgFill({ color, $disabled }),
    },
  }),
);
